import {createAsyncThunk, createSelector, createSlice} from '@reduxjs/toolkit';
import {isEqual} from 'lodash';
import {RootState} from '../store';
import {getAllUsers} from './usersAPI';

export interface IAllUsersAPIResponse {
  projectCount: number;
  values: IUser[];
}

export interface IUser {
  active: number
  default_project: string
  default_project_id: string
  email: string
  id: number
  isAdmin: string
  isUserInCurrentProject: boolean
  rn: string
  total_projects: number
  username: string
  notificationOn: boolean
  adminBadgeOn: boolean
  hasAssignedActionAlerts?: boolean
  actionAlertDashboardCount?:any
}

interface IUsersState {
  isLoading: boolean;
  users: IAllUsersAPIResponse;
}

const initialState: IUsersState = {
  isLoading: false,
  users: {
    projectCount: 0,
    values: [], 
  },
}

export const loadAllUsers = createAsyncThunk(
  'allUsers/get',
  async () => {
    const response = await getAllUsers();
    return response;
  }
);

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    updateUsersState(state: IUsersState, action) {
      state.users = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAllUsers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(loadAllUsers.fulfilled, (state, action) => {
      if (action.payload) {
        state.users.values = action.payload.values;
        state.users.projectCount = action.payload.projectCount;
        state.isLoading = false;
      }
    });
  },
})

export const selectUsersState = (state: RootState) =>
  state.users;
  export default usersSlice.reducer;
